import { useState, useEffect } from "react";
import "../../../assets/css/admin/modals/EditModal.css";

const defaultForm = {
  gen: "",
  name: "",
  president: "",
  vicePresident: "",
  reportUrl: "",
};

function EditModal({ isOpen, onClose, data, onSave }) {
  const isEdit = Boolean(data);

  const [form, setForm] = useState(defaultForm);

  useEffect(() => {
    if (!isOpen) return;

    if (!data) {
      setForm(defaultForm);
      return;
    }

    const members = data.members || "";

    const presidentMatch = members.match(/총:\s*([^,]+)/);
    const viceMatch = members.match(/부총:\s*(.+)/);

    setForm({
      gen: data.gen || "",
      name: data.name || "",
      president: data.president || (presidentMatch ? presidentMatch[1] : ""),
      vicePresident:
        data.vicePresident || (viceMatch ? viceMatch[1] : ""),
      reportUrl: data.reportUrl || "",
    });
  }, [isOpen, data]);

  useEffect(() => {
    if (!isOpen) return;

    const handleEsc = (e) => {
      if (e.key === "Escape") onClose();
    };

    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSave = () => {
    if (!form.gen.trim()) {
      alert("대수를 입력해 주세요.");
      return;
    }

    if (!form.name.trim()) {
      alert("이름을 입력해 주세요.");
      return;
    }

    if (!form.president.trim()) {
      alert("총학생회장을 입력해 주세요.");
      return;
    }

    onSave(form);
  };

  return (
    <div className="edit-modal-overlay" onClick={onClose}>
      <div className="edit-modal" onClick={(e) => e.stopPropagation()}>
        <h2 className="edit-modal-title">
          {isEdit ? "역대 총학생회 수정" : "역대 총학생회 추가"}
        </h2>

        <div className="edit-modal-form-group">
          <label>대수</label>
          <input
            name="gen"
            value={form.gen}
            onChange={handleChange}
            placeholder="예: OO대"
          />
        </div>

        <div className="edit-modal-form-group">
          <label>이름</label>
          <input
            name="name"
            value={form.name}
            onChange={handleChange}
            placeholder="예: OO"
          />
        </div>

        <div className="edit-modal-form-group">
          <label>활동 보고</label>

          <input
            name="reportUrl"
            value={form.reportUrl}
            onChange={handleChange}
            placeholder="활동 보고 URL을 입력해 주세요."
          />
        </div>

        <div className="edit-modal-divider" />

        <div className="edit-modal-section-title">구성원</div>

        <div className="edit-modal-form-group">
          <label>총학생회장</label>
          <input
            name="president"
            value={form.president}
            onChange={handleChange}
            placeholder="총학생회장 이름을 입력해 주세요."
          />
        </div>

        <div className="edit-modal-form-group">
          <label>부총학생회장</label>
          <input
            name="vicePresident"
            value={form.vicePresident}
            onChange={handleChange}
            placeholder="부총학생회장 이름을 입력해 주세요."
          />
        </div>

        <div className="edit-modal-buttons">
          <button type="button" className="edit-modal-cancel" onClick={onClose}>
            취소
          </button>

          <button type="button" className="edit-modal-save" onClick={handleSave}>
            저장
          </button>
        </div>
      </div>
    </div>
  );
}

export default EditModal;